import { render, staticRenderFns } from "./UserMgmtForCustomer.vue?vue&type=template&id=9b44693e"
import script from "./UserMgmtForCustomer.vue?vue&type=script&lang=js"
export * from "./UserMgmtForCustomer.vue?vue&type=script&lang=js"
import style0 from "./UserMgmtForCustomer.vue?vue&type=style&index=0&id=9b44693e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports